import { render, staticRenderFns } from "./SurveyManagementEditDateQuestion.vue?vue&type=template&id=32b98fcc&"
import script from "./SurveyManagementEditDateQuestion.vue?vue&type=script&lang=js&"
export * from "./SurveyManagementEditDateQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./SurveyManagementEditDateQuestion.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32b98fcc')) {
      api.createRecord('32b98fcc', component.options)
    } else {
      api.reload('32b98fcc', component.options)
    }
    module.hot.accept("./SurveyManagementEditDateQuestion.vue?vue&type=template&id=32b98fcc&", function () {
      api.rerender('32b98fcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/survey-management/edit-question/questions/SurveyManagementEditDateQuestion.vue"
export default component.exports